import React from 'react';
import { motion } from 'framer-motion';
import { CheckSquare, Zap, Dumbbell, Flame, DollarSign, Wrench, Palette, Trees } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
const bonuses = [{
  num: '#1',
  title: 'Checklist CERO ERROR Antes de Cortar',
  value: 9.99,
  description: <>
        Tu seguro anti-desastres: revisá{' '}
        <span className="text-white font-bold" data-id="element-26">
          TODO antes de hacer el primer corte.
        </span>{' '}
        Evitá errores costosos y material desperdiciado.
      </>,
  icon: CheckSquare,
  image: 'https://cdn.magicpatterns.com/uploads/5eDhPP2EZ3WvQfpGAdVVNM/ChatGPT_Image_20_ene_2026,_09_03_43_p.m._(1).png'
}, {
  num: '#2',
  title: 'Acelerador de Resultados — Ruta Express 7 Días',
  value: 14.99,
  description: <>
        Cronograma día por día para montar tu taller profesional en{' '}
        <span className="text-white font-bold" data-id="element-27">UNA semana</span> y tener tu
        primera pieza terminada.
      </>,
  icon: Zap,
  image: 'https://cdn.magicpatterns.com/uploads/jDM2eo8dpsXRoS6FdHdKs7/Bonus_2.png'
}, {
  num: '#3',
  title: 'Planos de Alto Valor — Trailers y Gym',
  value: 19.99,
  description: <>
        Planos exclusivos para fabricar equipamiento fitness que se vende a{' '}
        <span className="text-white font-bold" data-id="element-28">precios PREMIUM.</span> Tu atajo
        al mercado de alto valor.
      </>,
  icon: Dumbbell,
  image: 'https://cdn.magicpatterns.com/uploads/vtcrZh4VwQTU2ikksSDNPP/Bonus_3.png'
}, {
  num: '#4',
  title: 'Aprende a Soldar Desde Cero',
  value: 14.99,
  description: <>
        Guía técnica completa: tipos de soldadura, configuraciones, posiciones y
        errores comunes.{' '}
        <span className="text-white font-bold italic" data-id="element-29">
          Sin experiencia previa necesaria.
        </span>
      </>,
  icon: Flame,
  image: 'https://cdn.magicpatterns.com/uploads/r8gdQtuYWki9auxQ8d6Tw8/Bonus_4.png'
}, {
  num: '#5',
  title: 'Presupuesto y Ventas — Cierre Garantizado',
  value: 19.99,
  description: <>
        Cómo cotizar trabajos con seguridad y{' '}
        <span className="text-white font-bold" data-id="element-30">
          cerrar clientes sin regalar tu trabajo.
        </span>{' '}
        Fórmulas de precios y scripts de venta.
      </>,
  icon: DollarSign,
  image: 'https://cdn.magicpatterns.com/uploads/vGjQZfHd7B5mHSCi4WKg7V/Bonus_5.png'
}, {
  num: '#6',
  title: 'Torneria Desde Cero — Fundamentos Completos',
  value: 12.99,
  description: <>
        ¿Nunca tocaste un torno? Esta guía te lleva de la mano desde lo más
        básico hasta tu primer proyecto{' '}
        <span className="text-white font-bold" data-id="element-31">sin miedo.</span>
      </>,
  icon: Wrench,
  image: 'https://cdn.magicpatterns.com/uploads/vPMutUr53vm8zudKQrkCZM/Bonus_6.png'
}, {
  num: '#7',
  title: 'Herrería Artística — Diseño Superior',
  value: 14.99,
  description: <>
        Proyectos con enfoque estético de alta gama. Creá piezas que son{' '}
        <span className="text-white font-bold" data-id="element-32">verdaderas obras de arte</span>{' '}
        en metal y diferenciáte.
      </>,
  icon: Palette,
  image: 'https://cdn.magicpatterns.com/uploads/sXbU8EL9fbV1SYeBK71sFY/Bonus_7.png'
}, {
  num: '#8',
  title: 'Carpintería Que Vende — +100 Planos de Madera',
  value: 19.99,
  description: <>
        +100 planos de madera para combinar con hierro. Dominá ambos materiales
        y{' '}
        <span className="text-white font-bold" data-id="element-33">
          duplicá tu catálogo de productos.
        </span>
      </>,
  icon: Trees,
  image: 'https://cdn.magicpatterns.com/uploads/ottjURtgtDYKAcZ857xCRb/Bonus_8.png'
}];
export function BonusSection() {
  return <section className="py-8 px-4 bg-[#111]" data-id="element-34">
      <div className="max-w-5xl mx-auto border-2 border-[#FFD700] rounded-xl p-5 md:p-8 relative bg-[#0d0d0d] shadow-[0_0_40px_rgba(255,215,0,0.1)]" data-id="element-35">
        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-[#FFD700] text-black px-8 py-3 rounded-full font-black uppercase tracking-wider shadow-[0_0_20px_rgba(255,215,0,0.4)] text-base whitespace-nowrap border-4 border-[#0d0d0d]" data-id="element-36">
          🎁 8 Bonos Exclusivos Si Ordenás Hoy
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-37">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.04
        }} className={`bg-[#1a1a1a] border-l-4 border-[#FFD700] rounded shadow-lg hover:bg-[#222] transition-colors ${bonus.image ? 'p-0 overflow-hidden' : 'p-5 flex gap-4 items-start'}`} data-id="element-38">
              {bonus.image ? <>
                  <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-contain" data-id="element-39" />
                  <div className="p-4 flex gap-4 items-start" data-id="element-40">
                    <div className="bg-[#FFD700] text-black font-bold text-sm w-8 h-8 rounded flex items-center justify-center flex-shrink-0 shadow-md" data-id="element-41">
                      {bonus.num}
                    </div>
                    <div className="flex-1" data-id="element-42">
                      <h3 className="text-lg font-bold text-white mb-1 leading-tight" data-id="element-43">
                        {bonus.title}
                      </h3>
                      <p className="text-gray-400 text-sm mb-2 leading-relaxed" data-id="element-44">
                        {bonus.description}
                      </p>
                      <div className="text-sm bg-[#0d0d0d] inline-block px-2 py-1 rounded border border-[#333]" data-id="element-45">
                        <span className="text-[#EF4444] line-through font-bold" data-id="element-46">
                          Valor{' '}
                          <PriceDisplay amount={bonus.value} className="inline" data-id="element-47" />
                        </span>
                        <span className="ml-2 text-[#22C55E] font-black uppercase" data-id="element-48">
                          — ¡GRATIS!
                        </span>
                      </div>
                    </div>
                  </div>
                </> : <>
                  <div className="bg-[#FFD700] text-black font-bold text-sm w-8 h-8 rounded flex items-center justify-center flex-shrink-0 shadow-md" data-id="element-49">
                    {bonus.num}
                  </div>
                  <div className="flex-1" data-id="element-50">
                    <h3 className="text-lg font-bold text-white mb-1 leading-tight" data-id="element-51">
                      {bonus.title}
                    </h3>
                    <p className="text-gray-400 text-sm mb-2 leading-relaxed" data-id="element-52">
                      {bonus.description}
                    </p>
                    <div className="text-sm bg-[#0d0d0d] inline-block px-2 py-1 rounded border border-[#333]" data-id="element-53">
                      <span className="text-[#EF4444] line-through font-bold" data-id="element-54">
                        Valor{' '}
                        <PriceDisplay amount={bonus.value} className="inline" data-id="element-55" />
                      </span>
                      <span className="ml-2 text-[#22C55E] font-black uppercase" data-id="element-56">
                        — ¡GRATIS!
                      </span>
                    </div>
                  </div>
                </>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}